module.exports = __webpack_public_path__ + "static/img/10001 (5).47de4e2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10001 (5).webp
// module id = 8QpC
// module chunks = 14